/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ResetPasswordRequestUser } from './ResetPasswordRequestUser';
import {
    ResetPasswordRequestUserFromJSON,
    ResetPasswordRequestUserFromJSONTyped,
    ResetPasswordRequestUserToJSON,
} from './ResetPasswordRequestUser';

/**
 * 
 * @export
 * @interface ResetPasswordRequest
 */
export interface ResetPasswordRequest {
    /**
     * 
     * @type {ResetPasswordRequestUser}
     * @memberof ResetPasswordRequest
     */
    user?: ResetPasswordRequestUser;
}

/**
 * Check if a given object implements the ResetPasswordRequest interface.
 */
export function instanceOfResetPasswordRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ResetPasswordRequestFromJSON(json: any): ResetPasswordRequest {
    return ResetPasswordRequestFromJSONTyped(json, false);
}

export function ResetPasswordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResetPasswordRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': !exists(json, 'user') ? undefined : ResetPasswordRequestUserFromJSON(json['user']),
    };
}

export function ResetPasswordRequestToJSON(value?: ResetPasswordRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': ResetPasswordRequestUserToJSON(value.user),
    };
}

